import React from "react";
import AdminOnly from "~/components/AdminOnly";
import CustomeButton from "~/components/Button";
import PropTypes from "prop-types";

const EmptyDataView = ({ Icon, Header, Description, setModalVisible }) => {
  return (
    <div className="flex flex-column justify-content-center align-items-center p-5 empty__data__view">
      {Icon && <div className="empty__data__view--icon m-0">{Icon}</div>}
      {Header && <p className="empty__data__view--header">{Header}</p>}
      <AdminOnly>
        {Description && (
          <p className="empty__data__view--description">{Description}</p>
        )}
        <CustomeButton
          label="Add Share Transaction"
          className="access-btn"
          icon="pi pi-plus"
          iconPos="right"
          onClick={() => setModalVisible(true)}
        />
      </AdminOnly>
    </div>
  );
};
EmptyDataView.proptypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.string,
  setModalVisible: PropTypes.func,
};

export default EmptyDataView;
